import { render, staticRenderFns } from "./newChapter.vue?vue&type=template&id=e323f46c&scoped=true&"
import script from "./newChapter.vue?vue&type=script&lang=js&"
export * from "./newChapter.vue?vue&type=script&lang=js&"
import style0 from "./newChapter.vue?vue&type=style&index=0&id=e323f46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e323f46c",
  null
  
)

export default component.exports